export class ValidationErrors<E extends string> {
  private data: { [key: string]: string } = {}

  set(key: E, value: string) {
    this.data[key] = value
    return this
  }

  get(key: E) {
    return this.data[key] ?? ''
  }

  remove(...keys: E[]) {
    for (const key of keys) {
      delete this.data[key]
    }

    return this
  }

  isEmpty() {
    return Object.keys(this.data).length === 0
  }

  clone() {
    const newObject = new ValidationErrors<E>()
    newObject.data = { ...this.data }
    return newObject
  }
}
